import { render, staticRenderFns } from "./NetPromoterScore.vue?vue&type=template&id=5a0eaa4b&scoped=true"
import script from "./NetPromoterScore.vue?vue&type=script&lang=js"
export * from "./NetPromoterScore.vue?vue&type=script&lang=js"
import style0 from "./NetPromoterScore.vue?vue&type=style&index=0&id=5a0eaa4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0eaa4b",
  null
  
)

export default component.exports